import type {
  UrlMatchingRulePayloadType,
  UrlMatchingRuleServerPayloadType,
  UrlMatchingRuleServerType,
  UrlMatchingRuleType,
} from '@/lib/types/url-matching-rules.types'

export const normalizeUrlMatchingRule = (data: UrlMatchingRuleServerType): UrlMatchingRuleType => {
  return {
    id: data.id,
    advertiserId: data.advertiser_id,
    isMain: data.is_main,
    type: data.type,
    keyword: data.keyword,
    url: data.url,
    updatedAt: data.updated_at,
    ...(data.updated_by && {
      updatedBy: {
        id: data.updated_by.id,
        name: data.updated_by.username,
      },
    }),
  }
}

export const serializeUrlMatchingRulePayload = (
  data: UrlMatchingRulePayloadType,
): UrlMatchingRuleServerPayloadType => {
  return {
    is_main: data.type === 'allow' ? data.isMain : false,
    type: data.type,
    url: data.url || null,
    keyword: data.keyword || null,
  }
}
